module.exports = __webpack_public_path__ + "static/media/handbag.7cbea682.jpg";